import React from "react";
import { observer } from "mobx-react";
import {
  generatePath,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import WorkoutStore from "stores/WorkoutStore";
import { Page } from "components/Layout";
import Cards from "components/Workout/Cards";
import NavList from "../NavList";
import ROUTES from "navigation/routes";
import { Background } from "./styles";

// interface LocationState {
//   id?: number;
//   title?: string;
// }

// type Params = { categoryId: string; workoutGroup?: string };
type Props = {};

const WorkoutCategoryDetails: React.FC<Props> = observer(() => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const details = WorkoutStore.details;
  const familyId = location.state?.familyId;
  const familyTitle = location.state?.familyTitle;

  const onNavigateToWorkout = (workoutGroup?: string) => (workout: any) => {
    const { id: workoutId, title } = workout;
    const path = workoutGroup
      ? generatePath(ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS_WORKOUT_DETAILS, {
          categoryId: Number.parseInt(categoryId || ""),
          workoutId,
          workoutGroup,
        })
      : generatePath(ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUT_DETAILS, {
          categoryId: Number.parseInt(categoryId || ""),
          workoutId,
        });

    navigate(path, { state: { categoryId: categoryId, categoryTitle: details?.title, id: workoutId, workoutTitle: title, familyId: familyId, familyTitle: familyTitle } });
  };

  const onViewAllClick = (workoutGroup: string) => () => {
    navigate(
      generatePath(ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS, {
        categoryId: Number.parseInt(categoryId || ""),
        workoutGroup,
      }),
      { state: { id: categoryId, categoryTitle: details?.title, groupTitle: workoutGroup, familyId: familyId, familyTitle: familyTitle } },
    );
  };

  return (
    <Page
      title={details?.title}
      contentBackground={
        <>
          <Background />
          <Background leftDots />
        </>
      }
      topNavigation={<NavList />}
    >
      <Cards
        categoryId={Number.parseInt(categoryId || "")}
        onNavigateToWorkout={onNavigateToWorkout}
        onViewAllClick={onViewAllClick}
        url={location.pathname}
        history={undefined}
        familyId={Number.parseInt(familyId || "")}
      />
    </Page>
  );
});

export default WorkoutCategoryDetails;
